import { gql } from '@apollo/client'

export const userFrag = gql`
  fragment UserClock on User {
    id
    name
    isClockedIn
    mostRecentClockEvent {
      id
      clockInTime
      clockOutTime
    }
  }
`

export const changeClockMutation = gql`
  mutation ChangeClockMutation($isClockedIn: Boolean!) {
    setClockedIn(isClockedIn: $isClockedIn) {
      id
      user {
        ...UserClock
      }
    }
  }
  ${userFrag}
`

export const fetchMostRecentClockEventQuery = gql`
  query FetchMostRecentClockEvent {
    self {
      ...UserClock
    }
  }
  ${userFrag}
`
